// extracted by mini-css-extract-plugin
var _1 = "TeammatesRow-module__animateUploadProgressBarWidth--we3qb";
var _2 = "TeammatesRow-module__animatedBackground--b99Ce";
var _3 = "TeammatesRow-module__avatar--nMp_Z";
var _4 = "TeammatesRow-module__deactivated--PDTM6";
var _5 = "TeammatesRow-module__email--Af2Ts";
var _6 = "TeammatesRow-module__menu--Y711s";
var _7 = "TeammatesRow-module__name--xcwHb";
var _8 = "TeammatesRow-module__row--HZA3X";
var _9 = "TeammatesRow-module__status--kdab7";
var _a = "TeammatesRow-module__type--LDco6";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatar", _4 as "deactivated", _5 as "email", _6 as "menu", _7 as "name", _8 as "row", _9 as "status", _a as "type" }
